import { array, boolean, object } from 'yup'
import { TowServiceAvailability } from './tow-service-availability.types'

// A localized message map, e.g. { en: '...', fr: '...' }. Allow arbitrary locale keys.
const LocalizedMessageSchema = object().test(
  'is-localized-message',
  'advisory message must be a map of locale strings',
  (value) =>
    value == null ||
    (typeof value === 'object' &&
      Object.values(value).every((v) => typeof v === 'string'))
)

// Per-destination tow-service-availability response. Only enabled and
// advisoryMessages are consumed; other fields (requestId, restrictionId,
// restrictionType) are accepted but ignored.
export const TowServiceAvailabilitySchema = object<TowServiceAvailability>().shape({
  enabled: boolean().required(),
  advisoryMessages: array().of(LocalizedMessageSchema).optional(),
})
